/**
 * Jerarquía de Roles en el Sistema Multi-Tenant
 */
export const ROLES = Object.freeze({
  MESSIAH: "messiah",           // Superusuario Root / Plataforma
  CLIENT: "client",             // Administrador de Tenant (B2B)
  ADMIN: "admin",               // Personal operativo (Fuerza de ventas, gerentes)
  CUSTOMER: "customer",         // Cliente final (B2C)
});

/**
 * Estatus de Entidades
 */
export const STATUS = Object.freeze({
  ACTIVE: "active",
  INACTIVE: "inactive",
  SUSPENDED: "suspended",
});

/**
 * Scopes M2M Estándar para Peticiones
 */
export const SCOPES = Object.freeze({
  ALL: "*",
  SESSION_GET: "session:read",
  SESSION_POST: "session:write",
  CUSTOMER_SESSION_POST: "customer:session:post",
  CATALOG_READ: "catalog:read",
  CATALOG_WRITE: "catalog:write",
});

/**
 * Endpoints de la API Backend (Relativos)
 */
export const API_ENDPOINTS = Object.freeze({
  // Autenticación de usuarios
  USER: {
    SESSION: "/user/session",
  },
  // Catálogo y Ventas
  CATALOG: "/catalog-system",

  OPERATIONAL: {
    SDKS: "/operational/sdks",
    ORDERS: "/operational/orders",
    USERS:{
      CLIENTS: "/operational/users/clients",
    },
    APPS: "/operational/apps",
    SERVICE_ACCOUNTS: "operational/service-accounts",
  }
});

/**
 * Constantes de Almacenamiento Local (LocalStorage)
 */
export const STORAGE_KEYS = Object.freeze({
  AUTH_TOKEN: "leidenfrost-authentication-token",
  USER_DATA: "leidenfrost-user",
  SDKS_DATA: "leidenfrost-sdks",
  CLIENTS_DATA: "leidenfrost-clients",
  APPS_DATA: "leidenfrost-clients",
  REFRESH_TOKEN: "leidenfrost-refresh-token",
  CART:"leidenfrost-cart",
  THEME: "leidenfrost-ui-theme",
});